
import * as React from 'react';
import styled from 'styled-components';

import { SidebarTab } from '@process-advisor/process-miner/shared/consts';
import { getColor, getFontSize, getFontWeight } from '@process-advisor/process-miner/shared/theme';
import { TabsTitles } from '@process-advisor/process-miner/navigation/sidebar/consts';

const Header = styled.div`
    font-size: ${getFontSize('normal')};
    font-weight: ${getFontWeight('bold')};
    margin-bottom: 5px;
    color: ${getColor('blue')}
`;

const Panel = styled.div<{ isActive: boolean }>`
    display: ${({ isActive }) => isActive ? 'block' : 'none'};
    width: 100%;
`;


type Props = {
    activeTab: SidebarTab,
    tab: SidebarTab
    title?: string;
}

export const SidebarPanel: React.FC<Props> = ({ activeTab, tab, title, children }) => (

    <Panel isActive={activeTab === tab}>
        { title ? <Header>{title}</Header> : <Header>{TabsTitles[tab]}</Header> }
        {(activeTab === tab) && children}
    </Panel>
);

